const enum UpdateMode {
  SINGLE = 'single',
  REPEATED = 'repeated',
}

export default UpdateMode;
